import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path className="warning" d="M3 1C1 1 1 3 1 3v10c0 2 2 2 2 2l10-.094C15 14.888 15 13 15 13V3c0-2-2-2-2-2zm5 2.031c1.814 0 3.629.618 5 1.875V6h-1.813c-1.842-1.41-4.53-1.41-6.373 0H3V4.906C4.371 3.65 6.186 3.031 8 3.031zm0 3.063c1.044 0 2.08.337 2.875 1 .043.018.085.04.125.062V8H5v-.813c.039-.033.08-.065.125-.093.795-.663 1.831-1 2.875-1zM8 9a2 2 0 110 4 2 2 0 010-4z" style={{
      marker: "none"
    }} color="#000" overflow="visible" fill="#f57900" /></svg>;
}

export default SvgComponent;